export enum ConnectPanelStatus {
  CheckingStatus = 'CheckingStatus',
  RegionNotSupported = 'RegionNotSupported',
  IngestionError = 'IngestionError',
  InsufficientPermission = 'InsufficientPermission',
  NoActiveLicense = 'NoActiveLicense',
  QuotaExceeded = 'QuotaExceeded',
  ReadyToTile = 'ReadyToTile',
  ReadyToTileNewVersion = 'ReadyToTileNewVersion',
  ReadyToView = 'ReadyToView',
  ReadyToRefresh = 'ReadyToRefresh',
  Refreshing = 'Refreshing',
  TilingError = 'TilingError',
  Tiling = 'Tiling',
  Viewing = 'Viewing',
}
